module.exports = __webpack_public_path__ + "static/LEBC-Hummingbird-d4d083ddeae99888f3df49f3dc85a39a.mp4";